import styled from 'styled-components';

import { Sorare } from '#src/atoms/icons/Sorare.tsx';

export const FootballLogo = styled(Sorare)`
  color: var(--c-blue-400);
  fill: var(--c-black);
`;
